import Modal from "components/modal/Modal";
import { StyledAlert } from "./style";
import useAlertStore from "stores/useAlertStore";
import { Button } from "components/button/Button/Button";

export const Alert = () => {
  const {
    alertTitle,
    alertMessage,
    alertCaption,
    alertSubMessage,
    alertIndicator,
    alertToggle,
  } = useAlertStore();
  return (
    <Modal title={alertTitle} modalToggle={alertToggle} fitSize={true}>
      <StyledAlert>
        <div className="title">
          {alertIndicator}

          {alertMessage.split("\n").map((message) => (
            <span key={message}>{message}</span>
          ))}
          {alertSubMessage &&
            alertSubMessage.split("\n").map((subMessage) => (
              <span className="sub-message" key={subMessage}>
                {subMessage}
              </span>
            ))}
        </div>

        {alertCaption && (
          <div className="footer-wrap">
            <Button
              color="primary"
              type="solid"
              size="large"
              label={alertCaption}
              width="12rem"
              onClick={() => alertToggle(false)}
            />
          </div>
        )}
      </StyledAlert>
    </Modal>
  );
};
